import { render, staticRenderFns } from "./ChangePw.vue?vue&type=template&id=ab2b02b0&"
import script from "./ChangePw.vue?vue&type=script&lang=js&"
export * from "./ChangePw.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports